<template>
  <div class="accordion" id="accordionExample">
    <div class="card" v-for="(item, index) in faqList" :key="index">
      <div class="card-header" id="headingOne">
        <h4 class="mb-0">
         {{item.title}}
        </h4>
      </div>
      <div :id="index">
        <div class="card-body">
          <span v-html="item.value"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      faqList: [
          {
            title: 'Τι σημαίνει η ΕΑ;',
            value: 'H ΕΑ είναι η Επιστρατεύουσα Αρχή ή διαφορετικά η Μονάδα Επιστράτευσης.'
          },
          {
            title: 'Τι σημαίνει η ΔΕΠΕΘ;',
            value: 'Η ΔΕΠΕΘ είναι η Διευθυνση Επιστράτευσης - Εθνοφυλακής.'
          },
          {
            title: 'Τι σημαίνει η ΔΕΠΣ;',
            value: 'Η ΔΕΠΣ είναι η Διοίκηση Επιστράτευσης.'
          },
          {
            title: 'Εάν κατά τη διαδικασία της εγγραφής μου εμφανισθεί το μήνυμα «ο λογαριασμός είναι υπό έλεγχο» τι σημαίνει αυτό;',
            value: 'Εάν εμφανισθεί το παραπάνω μήνυμα αυτό σημαίνει ότι δεν δύναται να συνεχισθεί η διαδικασία και η ολοκλήρωση της εγγραφής σας. Σε εύλογο χρονικό διάστημα θα σας σταλεί ενημέρωση με ηλεκτρονικό ταχυδρομείο (email) από την αρμόδια ΕΑ, για να προσπαθήσετε εκ νέου την εγγραφή σας'
          },
          {
            title: 'Πως μπορώ να βρώ το Σ.Α. (Στρατιωτικό Αριθμό)',
            value: 'Από την επίσημη σελίδα της Στρατολογίας (https://www.stratologia.gr) και ακολουθώντας τη διαδρομή «Υπηρεσίες – Πληροφορίες» → «Εύρεση Στρατιωτικού Αριθμού» (https://www.stratologia.gr/eyresh_sa)'
          },
          {
            title: 'Πως συμπληρώνω το Σ.Α. μου;',
            value: 'Εάν ο Στρατιωτικός μου Αριθμός εμφανίζεται με μορφή 15310101014 ή με μορφή 153/101010/14 ή με μορφή 153 101010 14 θα πρέπει να επιλέξω στο πρώτο πεδίο το 153, στο δεύτερο πεδίο να συμπληρώσω το 101010 και στο τρίτο πεδίο να επιλέξω το 2014. Ο Αριθμός Στρατιωτικού Μητρώου συμπληρώνεται πάντα με 6 αριθμητικά ψηφία. Π.χ το Σ.Α 153/111/14 συμπληρώνεται με το δεύτερο πεδίο να περιλαμβάνει τα μηδενικά ως εξής: πρώτο πεδίο 153, δεύτερο πεδίο 000111 και τρίτο πεδίο 2014.'
          },
          {
            title: 'Από που είναι δυνατή η πρόσβαση στην «Ηλεκτρονική Εφαρμογή Αποστολής Ειδοποίησης Εφέδρου» (efedros.army.gr);',
            value: 'Η πρόσβαση στην εφαρμογή είναι δυνατή:<br><br>α. Μέσω της ηλεκτρονικής διεύθυνσης «https://efedros.army.gr»<br>β. Μέσω υπερσυνδέσμου, ο οποίος βρίσκεται στην ιστοσελίδα του ΓΕΣ (www.army.gr/)<br>γ. Μέσω υπερσυνδέσμου, ο οποίος βρίσκεται στον ιστότοπο της Δνσης Επιστράτευσης - Επιφυλακής ΓΕΣ/Α4 (ΔΕΠΕΘ) (www.epistrateusi.army.gr).<br>δ. Μέσω της νέας Ενιαίας Ψηφιακής Πύλης της δημόσιας διοίκησης (www.gov.gr). ακολουθώντας τη διαδρομή «Στράτευση» → «Έφεδροι» → «Αποστολή Ειδοποίησης Εφέδρου».'
          },
          {
            title: 'Ποιοί είναι ο στόχοι της εφαρμογής',
            value: 'Οι στόχοι της εφαρμογής είναι οι κάτωθι:<br><br>α. Η επικαιροποίηση των ατομικών στοιχείων των εφέδρων από τους ιδίους.<br>β. Η δυνατότητα πληροφόρησης στοχευμένων ομάδων εφέδρων περί αδιαβάθμητων ανακοινώσεων, οι οποίες θα αναρτώνται από το ΓΕΣ/Α4 (ΔΕΠΕΘ) και τις Επιστρατεύουσες Αρχές (ΕΑ). Οι εν λόγω ανακοινώσεις θα αποστέλλονται ταυτόχρονα στα ηλεκτρονικά γραμματοκιβώτια (emails) των εφέδρων με τη μορφή προσωπικής πληροφόρησης (newsletters).<br>γ. Η αποστολή μηνυμάτων από τον έφεδρο στη Μονάδα που τον παρακολουθεί.'
          },
          {
            title: 'Πως μπορώ να συνδεθώ και ποιο φυλλομετρητή (browser) να χρησιμοποιήσω;',
            value: 'Η σύνδεση μπορεί να πραγματοποιηθεί από οποιονδήποτε Η/Υ συνδεδεμένο στο διαδίκτυο. Μπορείς να χρησιμοποιήσεις οποιονδήποτε browser, αλλά προτιμάται ο Mozilla Firefox και κυρίως χρησιμοποιώντας την ανώνυμη περιήγηση (Νέο Παράθυρο Ανώνυμης Περιήγησης).'
          },
          {
            title: 'Πού μπορώ να απευθυνθώ για να ζητήσω πληροφορίες σχετικά με την επιστρατευτική μου τοποθέτηση ή για την υπόψη εφαρμογή;',
            value: 'Μπορείτε να απευθυνθείτε στην Επιστρατευτική Αρχή (ΜΕ) που σας παρακολουθεί. Στοιχεία επικοινωνίας αναγράφονται στον ιστότοπο της Δνσης Επιστράτευσης - Εθνοφυλακής ακολουθώντας τη διαδρομή «Επικοινωνία» → «Τηλέφωνα» → «email Μονάδων Επιστράτευσης (ΜΕ)» (https://epistrateusi.army.gr/el/tilefona-email-monadon-epistrateysis-me)'
          },
          {
              title: 'Ποιοι έχουν τη δυνατότητα εγγραφής στην εφαρμογή;',
              value: 'Δυνατότητα εγγραφής στην παρούσα φάση έχει όλο το εφεδρικό δυναμικό (Έφεδροι Αξιωματικοί και Οπλίτες) του Στρατού Ξηράς. Σύντομα και οι Μόνιμοι εξ Εφεδρείας.'
          },
          {
              title: 'Εάν κατά τη διαδικασία της εγγραφής μου εμφανισθεί το μήνυμα «Θα πρέπει να συμπληρώσετε τα απαραίτητα πεδία της φόρμας» τι σημαίνει αυτό;',
              value: 'Για την ταυτοποίηση των στοιχείων του εφέδρου είναι απαραίτητη η συμπλήρωση ορισμένων στοιχείων όπως το Α.Σ.Μ. και το μητρώο αρρένων.' +
                  'Αν ο χρήστης δεν συμπληρώσει τα απαραίτητα στοιχεία, θα παρουσιαστεί κόκκινο πλαίσιο στα ελλιπή πεδία και θα εμφανιστεί το παραπάνω μήνυμα. ' +
                  'Για οδηγίες αναφορικά με τη συμπλήρωση του πεδίου, ο χρήστης μπορεί να επιλέξει το ερωτηματικό που βρίσκεται δίπλα από το πεδίο.'
          },
          {
              title: 'Πως συμπληρώνω το Μητρώο Αρρένων;',
              value: 'Συμπληρώνω το όνομα του μητρώου αρρένων στο πεδίο αναζήτησης. ' +
                  'Κατά τη διάρκεια της πληκτρολόγησης εμφανίζεται η λίστα των αποτελεσμάτων και επιλέγω το μητρώο αρρένων από τη συγκεκριμένη λίστα. ' +
                  'Διευκρινίζεται ότι τα αποτελέσματα είναι της μορφής: Νομαρχία, Δήμος, Δημοτικό Διαμέρισμα.'
          },
        ]
    }
  }
}
</script>

<style>
  .accordion {
    width: 65%;
    margin: auto;
  }
</style>